/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse, HttpContext, HttpContextToken, HttpResponse } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Observable, retry, throwError, timeout, timer } from 'rxjs';
import { getBearerToken } from '../utils/bearer.token';
import { BaseFiltroInputDto } from '../domain/DTOs/input/base-filtro.input.dto';

export const SKIP_GLOBAL_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

@Injectable()
export class BaseService {

  private readonly API: string;
  private static requestRetryTimes = environment.requestRetryTimes;
  private static requestRetryInterval = environment.requestRetryInterval;

  constructor(
    private http: HttpClient
  ) {
    this.API = environment.API;
  }

  public get<Output>(endPoint: string, retryTimes = BaseService.requestRetryTimes): Observable<Output> {
    return this.http.get<Output>(`${this.API}${endPoint}`, this.createRequestOptions()).pipe(
      timeout(environment.requestTimeout),
      retry({
        count: retryTimes,
        delay: (error: HttpErrorResponse, retryCount: number) => {
          return retryCount == retryTimes ? throwError(() => error) : timer(retryCount * BaseService.requestRetryInterval);
        }
      })
    )
  }

  public getBlob(endPoint: string, retryTimes = BaseService.requestRetryTimes, timeoutMs = environment.requestTimeout): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.API}${endPoint}`, {
      headers: new HttpHeaders().set('Authorization', `Bearer ${getBearerToken()}`),
      context: new HttpContext().set(SKIP_GLOBAL_ERROR_TOAST, true),
      responseType: 'blob',
      observe: 'response',
      withCredentials: true
    }).pipe(
      timeout(timeoutMs),
      retry({
        count: retryTimes,
        delay: (error: HttpErrorResponse, retryCount: number) => {
          return retryCount == retryTimes ? throwError(() => error) : timer(retryCount * BaseService.requestRetryInterval);
        }
      })
    )
  }

  public getArquivo(endPoint: string): Observable<HttpResponse<Blob>> {
    return this.getBlob(endPoint, 0, environment.downloadTimeout);
  }

  public getFiltered<Output>(endPoint: string, pesquisa: string, pageFilterModel: BaseFiltroInputDto, retryTimes = BaseService.requestRetryTimes): Observable<Output> {

    let paramsPaginacao: string;
    if (pesquisa) {
      paramsPaginacao = `?${pesquisa}&PaginaAtual=${pageFilterModel.PaginaAtual}&TamanhoPagina=${pageFilterModel.TamanhoPagina}`;
    } else {
      paramsPaginacao = `?PaginaAtual=${pageFilterModel.PaginaAtual}&TamanhoPagina=${pageFilterModel.TamanhoPagina}`;
    }

    return this.http.get<Output>(`${this.API}${endPoint}${paramsPaginacao}`, this.createRequestOptions()).pipe(
      timeout(environment.requestTimeout),
      retry({
        count: retryTimes,
        delay: (error: HttpErrorResponse, retryCount: number) => {
          return retryCount == retryTimes ? throwError(() => error) : timer(retryCount * BaseService.requestRetryInterval);
        }
      })
    )
  }

  public post(endPoint: string, data: any, retryTimes = BaseService.requestRetryTimes) {

    const options = this.createRequestOptions();
    const body = JSON.stringify(data);

    return this.http.post<any>(`${this.API}${endPoint}`, body, options).pipe(
      timeout(environment.requestTimeout),
      retry({
        count: retryTimes,
        delay: (error: HttpErrorResponse, retryCount: number) => {
          return retryCount == retryTimes ? throwError(() => error) : timer(retryCount * BaseService.requestRetryInterval);
        }
      })
    );
  }

  private createRequestOptions(params?: HttpParams) {
    return {
      headers: new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', `Bearer ${getBearerToken()}`),
      params: params,
      withCredentials: true
    };
  }
}
